import { render } from "./Func.vue?vue&type=template&id=0397e3e0&ts=true"
import script from "./Func.vue?vue&type=script&lang=ts"
export * from "./Func.vue?vue&type=script&lang=ts"

import "./Func.vue?vue&type=style&index=0&id=0397e3e0&lang=scss"

import exportComponent from "E:\\xiangqukejidaima\\米优时官网\\miyoushi-web (3)\\miyoushi-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__